(function (window, document, $) {

    $(document).ready(function () {
        // Houdingen filter ===============================================================================================

        function updateHoudingenFilter(e) {

            var $filterForm = $('.js-houdingen-filter');

            if (e !== null) {

                window.xhrPool.abortAll();

                $.ajax({
                    type: 'POST',
                    url: themevars.ajaxurl,
                    data: $filterForm.serialize(),
                    dataType: 'json',

                    complete: function (e) { },

                    success: function (response) {
                        var $target = $('[data-filter-target="houding"]');
                        $target.empty();

                        $('.houdingen-filter__letter-container li').hide();

                        if (!response.houdingen) {
                            var $newEl = $('<div class="filter-no-results col-xl-12 col-lg-12 col-md-12 col-12">Helaas, er zijn geen resultaten gevonden.</div>');
                            $newEl
                                .css('opacity', 0)
                                .appendTo($target)
                                .delay(i * 100)
                                .animate({ opacity: 1 });
                            $('.slider-navigation--right, .slider-navigation--left').hide();
                        } else {
                            for (var i in response.houdingen_az) {
                                $('#filter-houding-group-' + response.houdingen_az[i]).show();
                            }

                            var $content = $(response.houdingen);
                            $content.appendTo($target);
                            $('.slider-navigation--right, .slider-navigation--left').show();
                        }
                    },
                    error: function (e) { }
                });
            }
        }

        updateHoudingenFilter(null);
        $('body').on('change', '.houdingen-filter input', updateHoudingenFilter);

        // trigger change when querystring filter is present
        if (window.location.search.indexOf('search') != -1) {
            $('#houdingen-filter-search').trigger('change');
        }



        // Houdingen A-Z toggle ========================================================================================
        /*
        $('body').on('change', 'select.toggle-houding-lang', function (e) {
            $('body').trigger('toggle-houding-lang');

            var lang = $(this).val();

            $('[data-language-toggle]').each(function() {
                var attr = $(this).attr('data-language');
                if (attr === lang) {
                    $(this).removeClass('d-none');
                } else {
                    $(this).addClass('d-none');
                }
            });
        });
        */

        /*
        function runFilter(value) {
            Object.values([].slice.call(jQuery('[data-positions-list]').find('h3, ul')).filter(function(item) {
                return $(item).is(':visible') || $(item).hasClass('search-hide');
            }).reduce(function(acc, item, index) {
                if (item.localName === 'h3') {
                    var letter = item.innerHTML;
                } else {
                    var letter = item.previousElementSibling.innerHTML;
                }
                if (!acc[letter]) {
                    acc[letter] = { letter: letter };
                }
                acc[letter][item.localName] = $(item);
                if (item.localName === 'ul') {
                    var items = [].slice.call($(item).find('li')).map(function(item) {
                        var title = (item.innerHTML || '').toLowerCase();
                        return { item: $(item.closest('li')), match: title.indexOf(value) > -1 };
                    });
                    acc[letter].items = items;
                    acc[letter].count = items.filter(function(item) {
                        return item.match;
                    }).length;
                }
                return acc;
            }, {})).forEach(function(item, index, list) {
                if (item.count) {
                    $(item.h3).removeClass('search-hide');
                    $(item.ul).removeClass('search-hide');

                    item.items.forEach(function(i) {
                        if (i.match) {
                            i.item.removeClass('search-hide');
                        } else {
                            i.item.addClass('search-hide');
                        }
                    });
                } else {
                    $(item.h3).addClass('search-hide');
                    $(item.ul).addClass('search-hide');
                }
            });
        }

        $('#houdingen-az').on('keyup', '.positions-filter__search .search-field', function() {
            var value = $(this).val() || '';
            runFilter(value.toLowerCase());
        });

        function resetFilter() {
            $('#houdingen-az').find('.positions-filter__search .search-field').val('');
            $('#houdingen-az .search-hide').removeClass('search-hide');
        }
        */

        //$('body').on('toggle-houding-lang', resetFilter);
    });

}(window, document, jQuery));